import { useMemo } from "react";
import dayjs from "dayjs";

import { useTimezones } from "@hooks/useTimezones";
import { MeetingType } from "@enums/meetings.enum";
import type { IMeetingTag } from "@interfaces/tag.interface";
import { formatDateByTimezone } from "@utils/date.util";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IMeetingTag;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionMeeting = ({ item, ...rest }: Props) => {
  const { userTimezoneOffset } = useTimezones();

  const meetingBackground = useMemo(() => {
    switch (item.type) {
      case MeetingType.INVESTMENT_COMMITTEE:
        return "#EAB308";
      case MeetingType.PIPELINE_REVIEW:
        return "#10B981";
      case MeetingType.MEETING:
        return "#EF4444";
      default:
        return "";
    }
  }, [item.type]);
  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-2 p-2">
      <div className="flex items-center gap-1 flex-1 overflow-hidden">
        <div
          className="h-5 w-[3px] flex-shrink-0 rounded-[5px]"
          style={{ background: meetingBackground }}
        />
        <TagLabel>{item.title}</TagLabel>
      </div>
      <span className="self-end text-xs font-normal text-gray-450 text-invertedPrimary80">
        {formatDateByTimezone(item.start_time, userTimezoneOffset, "MMM D, YYYY")}
        <br />
        {formatDateByTimezone(item.start_time, userTimezoneOffset, "h:mmA")}
      </span>
    </div>
  );
};
